import React, { useEffect, useMemo, useState } from "react";
import { X } from "lucide-react";
import "./CommissionSelectModal.css";

const COMMISSIONS = [
  { id: "none", name: "Без комиссии", kind: "fixed", value: 0 },
  { id: "pct3", name: "Комиссия 3%", kind: "percent", value: 3 },
  { id: "pct5", name: "Комиссия 5%", kind: "percent", value: 5 },
  { id: "fix200", name: "Комиссия 200 ₸", kind: "fixed", value: 200 },
  { id: "fix500", name: "Комиссия 500 ₸", kind: "fixed", value: 500 },
];

const formatCommissionRight = (c) => {
  if (!c) return "—";
  if (c.kind === "percent") return `${c.value} %`;
  return `${Number(c.value || 0).toLocaleString()} ₸`;
};

const CommissionSelectModal = ({ open, onClose, selected, onSelect }) => {
  const [selectedId, setSelectedId] = useState(selected?.id || "none");

  useEffect(() => {
    if (!open) return;
    setSelectedId(selected?.id || "none");
  }, [open, selected]);

  const selectedObj = useMemo(() => {
    return COMMISSIONS.find((x) => x.id === selectedId) || COMMISSIONS[0];
  }, [selectedId]);

  const handleConfirm = () => {
    onSelect?.(selectedObj);
    onClose?.();
  };

  if (!open) return null;

  return (
    <div className="cmm-overlay" onMouseDown={onClose}>
      <div className="cmm-modal" onMouseDown={(e) => e.stopPropagation()}>
        <div className="cmm-header">
          <div className="cmm-title">Создать комиссию</div>
          <button className="cmm-close" onClick={onClose} aria-label="Закрыть">
            <X size={18} />
          </button>
        </div>

        <div className="cmm-headRow">
          <div className="cmm-headLeft">Название</div>
          <div className="cmm-headRight">Комиссия</div>
        </div>

        <div className="cmm-list">
          {COMMISSIONS.map((c) => (
            <button
              key={c.id}
              type="button"
              className={`cmm-row ${selectedId === c.id ? "selected" : ""}`}
              onClick={() => setSelectedId(c.id)}
            >
              <div className="cmm-left">
                <span className={`cmm-radio ${selectedId === c.id ? "on" : ""}`} />
                <span className="cmm-name">{c.name}</span>
              </div>

              <div className="cmm-right">{formatCommissionRight(c)}</div>
            </button>
          ))}
        </div>

        <button className="cmm-confirm" type="button" onClick={handleConfirm}>
          Выбрать
        </button>
      </div>
    </div>
  );
};

export default CommissionSelectModal;
